import React from "react";
import MenuCard from "../MenuCard";
import "./listItem.scss";
import VegIcon from "../../Assets/vegIcon.png";
import NonVegIcon from "../../Assets/nonVegIcon.png";
import Egg from "../../Assets/egg.png";
import EmptyScreen from "../EmptyScreen";
import FoodMenuCard from "../FooterNav/test";
import { diet, dietType } from "../../Utills/enums";
import { useSelector } from "react-redux";

const ListItem = ({ category, showNote = false }) => {
  const cart = useSelector((state) => state?.user.cart);
  const count = Object.keys(cart).length;

  if (!category) {
    return <EmptyScreen message="No category found." iconType="cross" />
  }

  const items = Array.isArray(category.items) ? category.items : [];

  if (items.length === 0) {
    return <EmptyScreen message="No menu items found." iconType="cross" />;
  }

  return (
    <ul className={`no-bullets ${(count !== 0) ? "extraMargin" : ""}`}>
      {/* todo: on click animation */}
      {category?.items.map((val) => (
        <MenuCard
          key={val.menuId}
          menuId={val.menuId}
          src={val.imageUrl}
          title={val.foodName}
          description={val.description}
          price={val.price}
          dietIcon={
            diet[val.foodTypeId] === "Veg" || diet[val.foodTypeId] === "Vegan"
              ? VegIcon
              : diet[val.foodTypeId] === "Egg"
                ? Egg
                : NonVegIcon
          }
          tab={category?.categoryId}
          unit={val}
          isAvailable={val.isAvailable}
          showNote={showNote}
        />
      ))}
    </ul>
  );
};

export default ListItem;
